/* eslint-disable react/jsx-no-target-blank */
import PropTypes from "prop-types";
import React from "react";

import { Card, CardHeader, CardTitle, CardText } from "@sincro/react-card";

export function StayInTheLoopCard({
  image,
  name,
  text,
  title,
  url = "#",
  ...props
}) {
  return (
    <a href={url} target="_blank" {...props}>
      <Card className="stayInLoopCard">
        {image && (
          <CardHeader className="sincro-cardHeader">
            <img src={image} alt={name} />
          </CardHeader>
        )}
        {title && <CardTitle large>{title}</CardTitle>}
        {text && <CardText>{text}</CardText>}
      </Card>
    </a>
  );
}

StayInTheLoopCard.propTypes = {
  /** Image used to illustrate card */
  image: PropTypes.node,
  /** String used as alt text for image */
  name: PropTypes.string,
  /** String to display as card description */
  text: PropTypes.string,
  /** String to display as main card title */
  title: PropTypes.string,
  /** URL to redirect to on click */
  url: PropTypes.string
};
